<template>
  <div class="show-user fl">
    <div class="user ccui-clearfix">
      <img :src="headLogo" class="fl" :class="logoClass" />
      <div class="fl">
        <template v-if="loginInfo.mobile">
          <div class="user-type-welcome ell" :title="loginInfo.mobile">
            {{ loginInfo.mobile }}
          </div>
          <div class="user-type-log-out">
            <el-link
              :underline="false"
              type="info"
              class="fr view-all"
              @click="goTo"
              :class="[languagezh_cn ? '' : 'font-en']"
            >
              <!-- 业务协同待办 -->
              {{ $t("page.content.businessCoordinationToBeDone") }}
              <span style="color:red;margin-left:5px" v-if="todoTotal">{{
                todoTotal
              }}</span></el-link
            >
            <!-- <br v-show="!languagezh_cn" /> -->
            <span
              @click="handleExit"
              :style="languagezh_cn ? 'float: right' : 'float: left'"
              >{{ $t("page.content.Exit") }}</span
            >
          </div>
        </template>
        <template v-else>
          <div
            :class="[
              'user-type-welcome',
              languagezh_cn ? '' : 'user-type-welcome-en'
            ]"
          >
            {{ $t("page.content.welcomeToBack") }}
          </div>
          <a class="user-type-link" @click="handleLogin"
            >{{ $t("page.content.loginText") }}></a
          >
        </template>
      </div>
    </div>
    <div class="ccui-clearfix">
      <a @click="handleHelp(0)">
        <img
          class="fl help-center-img"
          :src="imgData[0] ? imgData[0].coverUrl : ''"
          style="width: 240px;height: 40px;"
        />
      </a>
      <a @click="handleHelp(1)">
        <img
          class="fl help-center-img"
          :src="imgData[1] ? imgData[1].coverUrl : ''"
          style="width: 240px;height: 36px;"
        />
      </a>
    </div>
    <div class="user-divider"></div>
    <div class="announcements-box">
      <div class="announcements-title ccui-clearfix">
        <span class="fl"
          ><i class="icon-ccui-trumpet"></i>
          <!--          <svg-icon icon-class="trumpet" class="icon-trumpet"></svg-icon>-->
          <span class="">{{ $t("page.content.Announcements") }}</span></span
        >
        <el-link
          :underline="false"
          type="info"
          class="fr color-1"
          @click="handleViewAll()"
          >{{ $t("page.content.MoreAndMore") }} ></el-link
        >
      </div>
      <ul class="announcements-ul">
        <template v-for="(item, index) in pageData">
          <li :key="index" class="ellipsis announcements-ul-li">
            <a @click="handleOp(item)" class="ellipsis" :title="item.title">{{
              item.title
            }}</a>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
import {
  queryPublishedNoticeList,
  updateHits,
  querySupToDoItemsQuantity,
  getSupInfoByLoginInfo
} from "@/app/shop/api/shopping";
import { getArgs } from "@/basa/utils";
import Cookies from "js-cookie";
export default {
  name: "showUser",
  props: {
    imgData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      pageData: [],
      todoTotal: ""
    };
  },
  activated() {
    this.init();
  },
  deactivated() {},
  methods: {
    init() {
      queryPublishedNoticeList({
        pageNo: 1,
        pageSize: 5,
        module: 1,
        pageState: 2,
        textType: 1,
        appId: 100123
      }).then(res => {
        if (res.data.code === "0") {
          this.pageData = res.data.data.rows.filter(item => {
            return item.textType == 1;
          });
        }
      });

      if (Cookies.get("access_token") && localStorage.appToken) {
        let loginId = JSON.parse(localStorage.getItem("userInfo")).loginId;
        getSupInfoByLoginInfo({
          loginId: loginId,
          agentId: this.$router.history.current.query.a,
          supCode: getArgs("SUPCODE")
        }).then(res => {
          this.getTodoTotal(res.data.data);
        });
      }
    },
    getTodoTotal(data) {
      let param = {
        supCodeList: [data.supCode],
        supCode: data.supCode
      };
      Object.assign(param, { agentId: this.$router.history.current.query.a });
      querySupToDoItemsQuantity(param).then(res => {
        let v = res.data.data;
        this.todoTotal =
          v.supplement +
          v.quotation +
          v.negotiation +
          v.bidBiding +
          v.bid +
          v.prequalification +
          v.answerQuestions +
          v.bidEvaluationClarification +
          v.sellingBid;
      });
    },
    handleHelp(index) {
      let item = this.imgData[index] ? this.imgData[index] : {};
      if (item.otherUrl) {
        //点击量
        updateHits({
          publicityContentId: item.publicityContentId
        });
        window.open(item.otherUrl, "_blank");
      }
    },
    //更多 >
    handleViewAll() {
      // let url = this.$router.resolve({
      //   path: "/announcementsList"
      // });
      // window.open(url.href, "_blank");

      let url = "/announcementsList";
      window.open(window.location.origin + url, "_blank");
    },
    goTo() {
      window.open(
        `${this.$addUrlPerFix(process.env.VUE_APP_BID_URL)}/?a=100121`
      );
    },
    handleOp(row) {
      // let url = this.$router.resolve({
      //   path: "/announcementDetail",
      //   query: {
      //     id: row.noticeInfoId,
      //     type: this.type
      //   }
      // });
      // window.open(url.href, "_blank");

      let params = ["id=" + row.noticeInfoId];
      let url = "/announcementDetail?" + params.join("&");
      window.open(window.location.origin + url, "_blank");
    },
    //退出
    handleExit() {
      sessionStorage.clear();
      localStorage.clear();
      Cookies.remove("access_token");
      Cookies.remove("refresh_token");
      // window.location.href = "/login";

      /*window.location.href =
        this.$addUrlPerFix("mla.iccec.cn/apis/mla/users/signup/doLogout") +
        "?ACCESS_TOKEN=" +
        Cookies.get("access_token") +
        "&redirectUrl=" +
        encodeURIComponent(
          this.$addUrlPerFix(process.env.VUE_APP_BASE_URL) + "/login"
        );*/
      window.location.href =
        this.$addUrlPerFix("mla.iccec.cn/apis/mla/users/signup/doLogout") +
        "?ACCESS_TOKEN=" +
        Cookies.get("access_token") +
        "&redirectUrl=" +
        encodeURIComponent(this.$addUrlPerFix(process.env.VUE_APP_BASE_URL));
    },
    //登录
    handleLogin() {
      // window.location.href = "/login";
      if (window.location.host == "sp.iccec.cn") {
        window.location.href = "http://ec.ccccltd.cn";
      } else {
        window.location.href =
          this.$addUrlPerFix(process.env.VUE_APP_LOGIN) +
          "?redirectUrl=" +
          this.$addUrlPerFix(process.env.VUE_APP_BASE_URL);
      }
    }
  },
  computed: {
    languagezh_cn() {
      return (Cookies.get("language") || "zh-cn") === "zh-cn";
    },
    loginInfo() {
      return this.$store.getters.getLoginInfo;
    },
    headLogo() {
      if (this.loginInfo.iConLink) {
        return this.loginInfo.iConLink;
      } else {
        return require("@/basa/assets/images/headLogo.png");
      }
    },
    logoClass() {
      if (this.loginInfo.name) {
        return "user-head_53 mr15";
      } else {
        return "user-head_52 mr16";
      }
    }
  }
};
</script>

<style scoped lang="scss">
.show-user {
  width: 260px;
  height: 370px;
  background: #ffffff;
  .user {
    margin: 26px 14px 20px 12px;
    .user-head_52 {
      width: 52px;
      height: 52px;
    }
    .user-head_53 {
      width: 53px;
      height: 53px;
    }
    .user-type-welcome {
      line-height: 28px;
      font-family: PingFang-SC-Medium;
      font-size: 20px;
      color: #4a4a4a;
      letter-spacing: 0;
      font-weight: 400;
      max-width: 165px;
    }
    .user-type-welcome-en {
      font-size: 19px;
    }
    .font-en {
      font-size: 13px;
    }
    .user-type-link {
      line-height: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-size: 13px;
      color: #4a4a4a;
      letter-spacing: 0;
      font-weight: 400;
      margin-top: 4px;
      display: block;
      &:hover {
        color: #0089ef;
      }
    }
    .user-type-log-out {
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999;
      margin-top: 1px;
      cursor: pointer;
      /*width: 30px;*/
      // span {
      //   float: right;
      // }
      .fr {
        margin-right: 10px;
        color: #0089ef;
        float: left;
      }
      &:hover {
        color: #0089ef;
      }
    }
  }
}

.icon-trumpet {
  width: 15.02px;
  height: 14px;
  padding-right: 7px;
}
.help-center-img {
  margin: 0 10px 10px;
}
</style>
